let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c37CC")).then(() => parcelRequire('cVptH'));